/**
 * Sticky Header
 * Adds a class to header on scroll
 */
// import Swiper from '../vendors/swiper-bundle.min';
// import odometer from '../vendors/odometer.min';
import '../vendors/lity.min';

jQuery( document ).on( 'scroll', function() {
	if ( jQuery( document ).scrollTop() > 0 ) {
		jQuery( 'header, body' ).addClass( 'shrink' );
	} else {
		jQuery( 'header, body' ).removeClass( 'shrink' );
	}
} );

jQuery( function() {
	/**
	 * Toggle menu for mobile
	 */
	// accessible sub menu
	jQuery( '.menu-item-has-children > a' )
		.focus( function() {
			jQuery( this ).siblings( '.sub-menu' ).addClass( 'focused' );
		} )
		.blur( function() {
			jQuery( this ).siblings( '.sub-menu' ).removeClass( 'focused' );
		} );

	jQuery( '.menu-btn' ).on( 'click', function() {
		jQuery( this ).toggleClass( 'active' );
		jQuery( '.nav-overlay' ).toggleClass( 'open' );
		jQuery( 'html, body' ).toggleClass( 'no-overflow' );
		jQuery( '.header-nav ul li.active' ).removeClass( 'active' );
		jQuery( '.header-nav ul.sub-menu' ).slideUp();
	} );
	jQuery.noConflict();

	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 */
	jQuery( 'li' ).each( function() {
		if ( jQuery( this ).hasClass( 'menu-item-has-children' ) ) {
			jQuery( this )
				.find( 'a:first' )
				.after( '<span class="submenu-icon"></span>' );
		}
	} );
	/**
	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	 */
	jQuery( document ).on( 'click', '.header-nav .menu-item span', function() {
		const link = jQuery( this ).parents( 'li' );

		link.siblings( '.active' ).removeClass( 'active' ).find( 'ul' ).slideUp();

		if ( link.hasClass( 'active' ) ) {
			link.removeClass( 'active' );
			link.parents( 'ul' ).removeClass( 'disabled-menu' );
			link.find( 'ul' ).slideUp();
		} else {
			link.addClass( 'active' );
			link.parents( 'ul' ).addClass( 'disabled-menu' );
			link.find( 'ul' ).slideDown();
		}
	} );

	// const swiper = new Swiper( '.swiper', {
	// 	loop: true,
	// 	slidesPerView: 'auto',
	// 	autoplay: {
	// 		delay: 5000,
	// 		disableOnInteraction: true,
	// 	},
	// 	centeredSlides: true,
	// 	navigation: {
	// 		nextEl: '.reviews-next',
	// 		prevEl: '.reviews-prev',
	// 	},

	// 	breakpoints: {
	// 		0: {
	// 			slidesPerView: 1,
	// 			centeredSlides: false,
	// 		},
	// 		1003: {
	// 			slidesPerView: 'auto',
	// 			centeredSlides: true,
	// 			spaceBetween: 30,
	// 		},
	// 	},
	// } );
	// function isInViewportCounter( $element ) {
	// 	if ( ! $element.length ) {
	// 		return false;
	// 	}

	// 	const rect = $element[ 0 ].getBoundingClientRect();
	// 	const elementMid = rect.top + rect.height / 2;
	// 	return elementMid > 0 && elementMid < window.innerHeight;
	// }

	// function runCounters() {
	// 	jQuery( '.odometer' ).each( function() {
	// 		const $this = jQuery( this );

	// 		if ( ! $this.hasClass( 'animated' ) && isInViewportCounter( $this ) ) {
	// 			const target = $this.data( 'number' );

	// 			if ( target !== undefined ) {
	// 				setTimeout( () => {
	// 					$this.text( target );
	// 				}, 300 );

	// 				$this.addClass( 'animated' );
	// 			}
	// 		}
	// 	} );
	// }
	// jQuery( window ).on( 'scroll load resize touchmove', runCounters );
	// jQuery( document ).ready( runCounters );

	if ( jQuery( '.cta-blocks' ).length > 0 ) {
		if ( jQuery( window ).width() > 1003 ) {
			( function( o, i ) {
				typeof exports === 'object' && typeof module < 'u' ? i( exports ) : typeof define === 'function' && define.amd ? define( [ 'exports' ], i ) : ( o = typeof globalThis < 'u' ? globalThis : o || self, i( o.aat = {} ) );
			}( this, function( o ) {
				'use strict'; function i( s, e, t ) {
					return Math.min( Math.max( s, e ), t );
				} function l( { from: s, to: e, percentage: t, unit: n } ) {
					return s + ( e - s ) * t + ( n || '' );
				} const a = { offsetBottom: 0, offsetTop: 0, offsetRight: 0, offsetLeft: 0, addWrapper: ! 1, wrapperClass: '', container: document.documentElement }; class c {
					static Container( e = document.documentElement ) {
						return new h( e );
					} static Element( e, t ) {
						return new d( e, { ...a, ...t } );
					} onScroll( e ) {
						this._handler = e, this._onScroll();
					}
				} class h extends c {
					constructor( e ) {
						super(), this._container = e, ( e === document.documentElement ? window : e ).addEventListener( 'scroll', this._onScroll.bind( this ) );
					} _onScroll() {
						const e = this._container.scrollTop,
							t = this._container.scrollHeight - this._container.clientHeight,
							n = i( e / t, 0, 1 ) || 0,
							r = this._container.scrollLeft,
							p = this._container.scrollWidth - this._container.clientWidth,
							_ = i( r / p, 0, 1 ) || 0; this._handler && typeof this._handler === 'function' && requestAnimationFrame( () => this._handler( { percentageY: n, percentageX: _ } ) );
					}
				} class d extends c {
					constructor( e, t ) {
						super(), this._element = e, this._options = t, this._lastPercentageY = null, this._lastPercentageX = null, this._options.addWrapper && this._addWrapper(), ( this._options.container === document.documentElement ? window : this._options.container ).addEventListener( 'scroll', this._onScroll.bind( this ) ), requestAnimationFrame( () => this._onScroll() );
					} _addWrapper() {
						this._wrapper = document.createElement( 'div' ), this._options.wrapperClass && this._wrapper.classList.add( this._options.wrapperClass ), this._element.parentNode.insertBefore( this._wrapper, this._element ), this._wrapper.appendChild( this._element );
					} get _containerClientHeight() {
						return this._options.container === window ? window.innerHeight : this._options.container.clientHeight;
					} get _containerClientWidth() {
						return this._options.container === window ? window.innerWidth : this._options.container.clientWidth;
					} get _elRectRelativeToContainer() {
						const t = ( this._options.addWrapper ? this._wrapper : this._element ).getBoundingClientRect(); if ( this._options.container === document.documentElement ) {
							return t;
						} const n = this._options.container.getBoundingClientRect(); return { width: t.width, height: t.width, left: t.left - n.left, top: t.top - n.top, right: t.right - n.right, bottom: t.bottom - n.bottom };
					} _calculatePercentageY() {
						const e = this._elRectRelativeToContainer,
							t = this._containerClientHeight - this._options.offsetBottom,
							n = this._options.offsetTop,
							r = t - n; return i( ( t - e.top ) / r, 0, 1 );
					} _calculatePercentageX() {
						const e = this._elRectRelativeToContainer,
							t = this._containerClientWidth - this._options.offsetRight,
							n = this._options.offsetLeft,
							r = t - n; return i( ( t - e.left ) / r, 0, 1 );
					} _onScroll() {
						const e = this._calculatePercentageY(),
							t = this._calculatePercentageX(); this._handler && typeof this._handler === 'function' && ( this._lastPercentageY !== e || this._lastPercentageX !== t ) && requestAnimationFrame( () => this._handler( { percentageY: e, percentageX: t } ) ), this._lastPercentageY = e, this._lastPercentageX = t;
					}
				} o.ScrollObserver = c, o.valueAtPercentage = l, Object.defineProperty( o, Symbol.toStringTag, { value: 'Module' } );
			} ) );

			const { ScrollObserver, valueAtPercentage } = aat;

			const cardsContainer = document.querySelector( '.cta-blocks' );
			const cards = document.querySelectorAll( '.cta-block-single' );
			cardsContainer.style.setProperty( '--cards-count', cards.length );
			cardsContainer.style.setProperty(
				'--card-height',
				`${ cards[ 0 ].clientHeight }px`
			);
			Array.from( cards ).forEach( ( card, index ) => {
				const offsetTop = 0 + index * 60;
				card.style.paddingTop = `${ offsetTop }px`;
				if ( index === cards.length - 1 ) {
					return;
				}
				const toScale = 1 - ( cards.length - 1 - index ) * 0.05;
				const nextCard = cards[ index + 1 ];
				const cardInner = card.querySelector( '.cta-block-single-inner ' );
				ScrollObserver.Element( nextCard, {
					offsetTop,
					offsetBottom: window.innerHeight - card.clientHeight,
				} ).onScroll( ( { percentageY } ) => {
					cardInner.style.scale = valueAtPercentage( {
						from: 1,
						to: toScale,
						percentage: percentageY,
					} );
					cardInner.style.filter = `brightness(${ valueAtPercentage( {
						// from: 1,
						// to: 1,
						percentage: percentageY,
					} ) })`;
				} );
			} );
		}
	}

	jQuery( '.pagination-mobile-number' ).on( 'click keypress', function() {
		const currentItem = jQuery( this );

		if ( currentItem.hasClass( 'active' ) ) {
			currentItem.removeClass( 'active' );
			currentItem.siblings( '.pagination-numbers-mobile' ).slideUp( 300 );
		} else {
			jQuery( '.pagination-mobile-number' ).removeClass( 'active' );
			jQuery( '.pagination-numbers-mobile' ).slideUp( 300 );

			currentItem.addClass( 'active' );
			currentItem.siblings( '.pagination-numbers-mobile' ).slideDown( 300 );
		}
	} );
	jQuery( document ).ready( function() {
		jQuery( '.copy-link' ).on( 'click', function() {
			const link = jQuery( this ).data( 'link' );
			const msg = jQuery( this ).siblings( '.copy-msg' );

			navigator.clipboard.writeText( link ); // copy to clipboard
			msg.show().delay( 2000 ).fadeOut( 200 ); // show text then hide
		} );
	} );

	jQuery( document ).on( 'click', '.copy-link', function( e ) {
		e.preventDefault();

		const link = $( this ).data( 'link' );
		const msg = $( this ).siblings( '.copy-msg' );

		navigator.clipboard.writeText( link );

		msg.fadeIn( 200 );

		setTimeout( () => msg.fadeOut( 200 ), 2000 );
	} );
	jQuery( '.faq-content' ).hide();
	const firstFaq = jQuery( '.faq-head' ).first();
	firstFaq.addClass( 'active' );
	firstFaq.siblings( '.faq-content' ).show();

	// Accordion toggle
	jQuery( '.faq-head' ).on( 'click keypress', function() {
		const currentFaq = jQuery( this );

		if ( currentFaq.hasClass( 'active' ) ) {
			currentFaq.removeClass( 'active' );
			currentFaq.siblings( '.faq-content' ).slideUp( 300 );
		} else {
			jQuery( '.faq-head' ).removeClass( 'active' );
			jQuery( '.faq-content' ).slideUp( 300 );

			currentFaq.addClass( 'active' );
			currentFaq.siblings( '.faq-content' ).slideDown( 300 );
		}
	} );
} );

